import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useMotionTemplate, useMotionValue } from "framer-motion";
import { featuredCategories } from "../../data/homeLuxury";

export default function FeaturedCategoryCards() {
  return (
    <section className="lux-categories" aria-labelledby="lux-cat-heading">
      <div className="lux-section-head">
        <p className="lux-eyebrow">Featured</p>
        <h2 id="lux-cat-heading" className="lux-h2">
          Shop by occasion
        </h2>
        <p className="lux-lead">Find the right box for every celebration.</p>
      </div>
      <ul className="lux-cat-grid">
        {featuredCategories.map((cat, index) => (
          <li key={cat.slug}>
            <CategoryTiltCard cat={cat} index={index} />
          </li>
        ))}
      </ul>
    </section>
  );
}

function CategoryTiltCard({ cat, index }) {
  const ref = useRef(null);
  const x = useMotionValue(0.5);
  const y = useMotionValue(0.5);
  const spotlight = useMotionTemplate`radial-gradient(420px circle at ${x} ${y}, rgba(255,255,255,0.45), transparent 55%)`;

  const move = (e) => {
    const el = ref.current;
    if (!el || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const r = el.getBoundingClientRect();
    x.set((e.clientX - r.left) / r.width);
    y.set((e.clientY - r.top) / r.height);
  };

  const leave = () => {
    x.set(0.5);
    y.set(0.5);
  };

  return (
    <motion.div
      ref={ref}
      className="lux-cat-card"
      style={{ backgroundImage: cat.gradient }}
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8%" }}
      transition={{ duration: 0.55, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
      onMouseMove={move}
      onMouseLeave={leave}
    >
      <motion.div
        className="lux-cat-card__inner"
        whileHover={{
          y: -10,
          rotateX: 4,
          rotateY: -4,
          transition: { type: "spring", stiffness: 260, damping: 22 },
        }}
        style={{ transformStyle: "preserve-3d" }}
      >
        <span className="lux-cat-card__shine" style={{ backgroundImage: spotlight }} />
        <Link to="/shop" state={{ filter: { search: cat.slug } }} className="lux-cat-card__link">
          <div className="lux-cat-card__media">
            {cat.image ? (
              <img
                src={cat.image}
                alt={`Shop ${cat.title} gift boxes — Rencin Gifting`}
                loading="lazy"
                decoding="async"
              />
            ) : (
              <div className="lux-cat-card__media-fallback" aria-hidden />
            )}
          </div>
          <div className="lux-cat-card__text">
            <h3>{cat.title}</h3>
            <p>{cat.subtitle}</p>
            <span className="lux-cat-card__cta">Discover</span>
          </div>
        </Link>
      </motion.div>
    </motion.div>
  );
}
